import { render, staticRenderFns } from "./sign-up.vue?vue&type=template&id=291d5cf3&"
import script from "./sign-up.vue?vue&type=script&lang=ts&"
export * from "./sign-up.vue?vue&type=script&lang=ts&"
import style0 from "./sign-up.vue?vue&type=style&index=0&module=true&lang=stylus&"
import style1 from "./sign-up.vue?vue&type=style&index=1&lang=stylus&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports